module.exports = __webpack_public_path__ + "media/subway/N-8329926c.png";